/* eslint-disable max-lines */
import freshDough from './assets/fresh_dough.jpg';
import thinCrust from './assets/thin_crust.jpg';
import cheese from './assets/cheese.png';
import pizzaSauce from './assets/pizza_sauce.jpg';
import bordeQueso from './assets/borde_queso.jpg';

export const CATEGORIES = {
  MEAT: 'meat',
  VEGETABLE: 'vegetable',
  EXTRA_CHEESE: 'extra_cheese',
  SHOT: 'shots',
  BASE: 'base',
  PREMIUM: 'premium',
  REGULAR: 'normal'
};

export const CATEGORIES_LIST = [
  CATEGORIES.BASE,
  CATEGORIES.MEAT,
  CATEGORIES.VEGETABLE,
  CATEGORIES.EXTRA_CHEESE,
  CATEGORIES.SHOT,
  CATEGORIES.PREMIUM
];

export const BASE_INGREDIENTS = {
  cl: [
    {
      name: 'Masa fresca',
      category: 'base',
      pictures: [
        {
          category: 'photo',
          url: freshDough
        }
      ],
      description:
        'Nuestra masa original es elaborada con harina de trigo con alto contenido proteico, es enviada a los locales fresca, nunca congelada. Nuestra consistencia en la preparación crea un sabor único que podrás disfrutar con tus ingredientes favoritos.'
    },
    {
      name: 'Masa delgada',
      category: 'base',
      pictures: [
        {
          category: 'photo',
          url: thinCrust
        }
      ],
      description:
        "Harina sin blanquear elaborada con nuestra fórmula patentada. La masa delgada de Papa John's es tan delgada y crujiente que sentirás el 'crunch' en cada mordida. Además no contiene conservantes."
    },
    {
      name: 'Queso base',
      category: 'base',
      pictures: [
        {
          category: 'photo',
          url: cheese
        }
      ],
      description:
        'Si eres amante al queso tienes que probar el nuestro. Es 100% Queso real. Además es bajo en grasa y elaborada con leche descremada de alta calidad.'
    },
    {
      name: 'Salsa de tomate',
      category: 'base',
      pictures: [
        {
          category: 'photo',
          url: pizzaSauce
        }
      ],
      description:
        "Nuestra exclusiva salsa de tomate de Papa John's se elabora con tomates frescos recién cosechados en el fértil valle de California, dónde se producen los tomates más ricos del mundo y son madurados naturalmente. Nuestra receta patentada no utiliza colorantes ni saborizantes artificiales."
    },
    {
      name: 'Borde queso',
      category: 'base',
      pictures: [
        {
          category: 'photo',
          url: bordeQueso
        }
      ],
      description:
        '¿Fanático del Queso? Ahora encontrarás nuestra exquisita Mozzarella 100% Real en el nuevo Borde de Queso.'
    }
  ],
  cr: [
    {
      name: 'Masa fresca',
      category: 'base',
      pictures: [
        {
          category: 'photo',
          url: freshDough
        }
      ],
      description:
        'Nuestra masa original es elaborada con harina de trigo con alto contenido proteico, es enviada a los locales fresca, nunca congelada. Nuestra consistencia en la preparación crea un sabor único que podrás disfrutar con tus ingredientes favoritos.'
    },
    {
      name: 'Masa thin crust',
      category: 'base',
      pictures: [
        {
          category: 'photo',
          url: thinCrust
        }
      ],
      description:
        "Harina sin blanquear elaborada con nuestra fórmula patentada. Nuestra masa delgada thin crust es tan delgada y crujiente que sentirás el 'crunch' en cada mordida. Además, no contiene conservantes."
    },
    {
      name: 'Queso base',
      category: 'base',
      pictures: [
        {
          category: 'photo',
          url: cheese
        }
      ],
      description:
        'Si eres amante al queso mozzarella tienes que probar el nuestro. Es 100% Queso real. Además, es bajo en grasa y elaborada con leche descremada de alta calidad.'
    },
    {
      name: 'Salsa de tomate',
      category: 'base',
      pictures: [
        {
          category: 'photo',
          url: pizzaSauce
        }
      ],
      description:
        "Nuestra exclusiva salsa de tomate de Papa John's se elabora con tomates frescos recién cosechados en el fértil valle de California, dónde se producen los tomates más ricos del mundo y son madurados naturalmente. Nuestra receta patentada no utiliza colorantes ni saborizantes artificiales."
    }
  ],
  es: [
    {
      name: 'Masa Original',
      category: 'base',
      pictures: [
        {
          category: 'photo',
          url: freshDough
        }
      ],
      description:
        'Hecha a diario en nuestro obrador con solo 6 ingredientes: harina, sal, azúcar, agua, aceite y levadura.'
    },
    {
      name: 'Masa fina',
      category: 'base',
      pictures: [
        {
          category: 'photo',
          url: thinCrust
        }
      ],
      description:
        'Masa fresca elaborada en nuestro obrador y estirada a mano para lograr una base fina y crujiente.'
    },
    {
      name: 'Queso mozzarella',
      category: 'base',
      pictures: [
        {
          category: 'photo',
          url: cheese
        }
      ],
      description: 'Auténtico queso mozzarella elaborado con leche fresca de vaca.'
    },
    {
      name: 'Salsa de tomate',
      category: 'base',
      pictures: [
        {
          category: 'photo',
          url: pizzaSauce
        }
      ],
      description:
        'Salsa de tomate elaborada con tomates cosechados en Badajoz y aceite oliva virgen extra. Sin conservantes.'
    }
  ],
  pt: [
    {
      name: 'Massa original',
      category: 'base',
      pictures: [
        {
          category: 'photo',
          url: freshDough
        }
      ],
      description:
        'Feita diariamente na nossa fábrica de massas com apenas 6 ingredientes: farinha, sal, açúcar, água, óleo e fermento.'
    },
    {
      name: 'Massa fina',
      category: 'base',
      pictures: [
        {
          category: 'photo',
          url: thinCrust
        }
      ],
      description:
        'Massa fresca feita na nossa fábrica de massas e esticada à mão para obter uma base fina e estaladiça.'
    },
    {
      name: 'Queijo Mozzarella',
      category: 'base',
      pictures: [
        {
          category: 'photo',
          url: cheese
        }
      ],
      description: 'Autêntico queijo mozzarella feito com leite de vaca fresco.'
    },
    {
      name: 'Molho de tomate',
      category: 'base',
      pictures: [
        {
          category: 'photo',
          url: pizzaSauce
        }
      ],
      description:
        'Molho de tomate feito com tomates de hortas locais e azeite virgem extra. Sem conservantes.'
    }
  ],
  // TODO: ADD PANAMA BASE INGREDIENTS DESCRIPTIONS
  pa: [
    {
      name: 'Masa fresca',
      category: 'base',
      pictures: [
        {
          category: 'photo',
          url: freshDough
        }
      ],
      description:
        'Nuestra masa original es elaborada con harina de trigo con alto contenido proteico, es enviada a los locales fresca, nunca congelada. Nuestra consistencia en la preparación crea un sabor único que podrás disfrutar con tus ingredientes favoritos.'
    },
    {
      name: 'Masa delgada',
      category: 'base',
      pictures: [
        {
          category: 'photo',
          url: thinCrust
        }
      ],
      description:
        "Harina sin blanquear elaborada con nuestra fórmula patentada. Nuestra masa delgada thin crust es tan delgada y crujiente que sentirás el 'crunch' en cada mordida. Además, no contiene conservantes."
    },
    {
      name: 'Queso base',
      category: 'base',
      pictures: [
        {
          category: 'photo',
          url: cheese
        }
      ],
      description:
        'Si eres amante al queso mozzarella tienes que probar el nuestro. Es 100% Queso real. Además, es bajo en grasa y elaborada con leche descremada de alta calidad.'
    },
    {
      name: 'Salsa de tomate',
      category: 'base',
      pictures: [
        {
          category: 'photo',
          url: pizzaSauce
        }
      ],
      description:
        "Nuestra exclusiva salsa de tomate de Papa John's se elabora con tomates frescos recién cosechados en el fértil valle de California, dónde se producen los tomates más ricos del mundo y son madurados naturalmente. Nuestra receta patentada no utiliza colorantes ni saborizantes artificiales."
    },
    {
      name: 'Borde queso',
      category: 'base',
      pictures: [
        {
          category: 'photo',
          url: bordeQueso
        }
      ],
      description:
        '¿Fanático del Queso? Ahora encontrarás nuestra exquisita Mozzarella 100% Real en el nuevo Borde de Queso.'
    }
  ],
  gt: [
    {
      name: 'Masa fresca',
      category: 'base',
      pictures: [
        {
          category: 'photo',
          url: freshDough
        }
      ],
      description:
        'Nuestra masa original es elaborada con harina de trigo con alto contenido proteico, es enviada a los locales fresca, nunca congelada. Nuestra consistencia en la preparación crea un sabor único que podrás disfrutar con tus ingredientes favoritos.'
    },
    {
      name: 'Masa delgada',
      category: 'base',
      pictures: [
        {
          category: 'photo',
          url: thinCrust
        }
      ],
      description:
        "Harina sin blanquear elaborada con nuestra fórmula patentada. La masa delgada de Papa John's es tan delgada y crujiente que sentirás el 'crunch' en cada mordida. Además no contiene conservantes."
    },
    {
      name: 'Queso base',
      category: 'base',
      pictures: [
        {
          category: 'photo',
          url: cheese
        }
      ],
      description:
        'Si eres amante al queso tienes que probar el nuestro. Es 100% Queso real. Además es bajo en grasa y elaborada con leche descremada de alta calidad.'
    },
    {
      name: 'Salsa de tomate',
      category: 'base',
      pictures: [
        {
          category: 'photo',
          url: pizzaSauce
        }
      ],
      description:
        "Nuestra exclusiva salsa de tomate de Papa John's se elabora con tomates frescos recién cosechados en el fértil valle de California, dónde se producen los tomates más ricos del mundo y son madurados naturalmente. Nuestra receta patentada no utiliza colorantes ni saborizantes artificiales."
    },
    {
      name: 'Borde queso',
      category: 'base',
      pictures: [
        {
          category: 'photo',
          url: bordeQueso
        }
      ],
      description:
        '¿Fanático del Queso? Ahora encontrarás nuestra exquisita Mozzarella 100% Real en el nuevo Borde de Queso.'
    }
  ]
};
